export default __webpack_public_path__ + "static/media/left-bottom-vinho.27004819.png";